//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	// import uniIcons from "components/uni-icon/uni-icon.vue"
	import uploadImage from "@/components/upload-image/index.vue"
	import uniLoadMore from "@/components/uni-load-more/uni-load-more.vue"
	import popupLayer from 'components/popup-layer/popup-layer.vue'
	import jsfunRecord from '@/components/jsfun-record/jsfun-record.vue'
	const innerAudioContext = uni.createInnerAudioContext()
export default {
	data(){
		return{
			imageList:[],
			name:'',
			bool:false,
			loading:false,
			addImageshow:true,
			boolShow:false,
			addressList:[],
			isStart: false,
			startVoice: 0,
			endVoice: 0,
			type: 'static',
			localId:'',
			form:{
				address:'所在位置',
				content:'',
				mediaUrl:'',
				mediaLen:0,
				lat:'',
				longt:''
			}
		}
	},
	components:{
		// uniIcons,
		uploadImage,
		popupLayer,
		uniLoadMore,
		jsfunRecord
	},
	onReady() {
		this.getLocation()
	},
	methods:{
		textInput(event){
			this.form.content=event.detail.value
		},
		nameInput(event){
			this.name=event.detail.value
			this.search()
		},
		remove(i){
			this.imageList.splice(i, 1)
		},
		addImage(image){
			this.imageList.push(image)
		},
		changeAddress(item){
			this.form.address=item.name
			this.boolShow=false
		},
		saveRecord(obj) {
			this.form.mediaUrl=obj.mediaUrl
			this.form.mediaLen=obj.mediaLen
			//do... 可以使用 uni.uploadFile 接口上传到服务器
		},
		removeAudio(){
			this.form.mediaUrl=''
			this.form.mediaLen=0
		},
		cancelSound () {
			uni.showModal({
				title: '提示',
				content: '文件未保存，取消会丢失，确认取消吗？',
				success: function (res) {
					if (res.confirm) {
						uni.navigateBack({
							delta:1
						})
						// uni.navigateTo({
						// 	url:'/pages/soundWall/list'
						// })
					}
				},
			})
		},
		playSounds(){		
			innerAudioContext.src=this.$getImg(this.form.mediaUrl)			
			let _this = this
			if(this.type=='static'){
				this.type='dynamic'					






				innerAudioContext.play()

				// window.jweixin.playVoice({
				//   	localId: _this.localId // 需要播放的音频的本地ID，由stopRecord接口获得
				// })
				setTimeout(() => {
					this.type = 'static'
				}, this.form.mediaLen * 1000)
			}
			else{
				this.type='static'
				// this.stopVoice()






				innerAudioContext.pause()

			}
		},
		stopVoice () {
			let _this = this
			window.jweixin.stopVoice({
				localId: _this.localId // 需要停止的音频的本地ID，由stopRecord接口获得
			})
		},
		async publish(){
			if(!this.bool){
			this.bool=true
			if(this.imageList.length==0){
				uni.showToast({
					title:'图片不能为空',
					icon:'none'
				})
				this.bool=false
				return
			}














			let {content,..._data}=this.form
			// this.form.content=encodeURI(this.form.content)
			this.$ajax({
				method: 'post',
				url: '/weChat/cms/share/add',
				data: {
					userId:this.$store.state.userInfo.memberId,
					images:this.imageList.join(','),
					..._data,
					content:encodeURI(content)
				}
			}).then(result=>{
				
				uni.showToast({
					title: '发布成功！跳转至列表...',
					icon:'none'
				})
				setTimeout(()=>{
					uni.redirectTo({
					url:'/pages/soundWall/list'
				})
				this.bool=false
				},500)
				
			}).catch(res=>{
				this.bool=false
			})
			}
	    },
		sendVoice () {
			if (this.isStart) {
				this.stopRecord()
			} else {
				window.jweixin.startRecord()
				this.isStart = true
				this.startVoice = Date.parse(new Date())
				uni.showToast({
					title:'开始录音...',
					icon:'none',
					duration: 0
				})
				setTimeout(() => {
					// 结束录音
					if (this.isStart) {
						uni.showToast({
							title:'最长1分钟',
							icon:'none',
							duration: 0
						})
						this.stopRecord()
					}
				}, 60000)
			}
		},
		stopRecord () {
			let _this = this
			window.jweixin.stopRecord({
				success: function (res) {
					_this.localId=res.localId
					window.jweixin.uploadVoice({
						localId: res.localId, // 需要上传的音频的本地ID，由stopRecord接口获得
						isShowProgressTips: 1, // 默认为1，显示进度提示
						success: function (res) {
							_this.form.mediaUrl = res.serverId
						}
					})
				}
			})
		  this.isStart = false
		  this.endVoice = Date.parse(new Date())
		  this.form.mediaLen = (this.endVoice - this.startVoice) / 1000
		},
		async uploadFiles (mediaId) {
			// let [error,res] = await uni.request({
			// 	method: 'post',
			// 	header:{"Content-Type": "application/x-www-form-urlencoded"},
			// 	url: this.$store.state.proxyUrl+'/weChat/file/upload',
			// 	data: {
			// 		files: files,
			// 		tenantId:this.$store.state.tenantId
			// 	}
			// })
			// let url=res.data.data[0].store
			
			// return url
			return this.$ajax({
				url:'/weChat/file/uploadWechatTempFileV2',
				data:{
					mediaId:mediaId
				}
			})
		},
		search(){
			this.loading=true
			let _this=this
			this.$ajax({
				method: 'post',
				url: '/weChat/cms/around/getAroundInfo',
				data: {
					keywords: this.name,
					offset: 100,
					page: 1
					// city: '金华'
				}
			}).then(result=>{
				_this.loading=false
				_this.addressList=_this.renderData(result.data.pois)
			})
		},
		renderData (data) {
			let re = new RegExp(this.name, 'g')
			return data.map(t => {
				let text = ''
				if (re.test(t.name)) {
					text = t.name.replace(re, '<span class="active">$&</span>')
				}
				return {
					...t,
					useName: text || t.name
				}
			})
		},
		getLocation(){
			let _this=this

			uni.getLocation({
				type: 'gcj02',
				success: function (res) {
					_this.form.lat = res.latitude // 纬度，浮点数，范围为90 ~ -90
					_this.form.longt = res.longitude // 经度，浮点数，范围为180 ~ -180。
					_this.$ajax({
						method: 'post',
						url: '/weChat/cms/locationname/getLocationName',
						data: {
							longitude: res.longitude,
							latitude: res.latitude
						}
					}).then(result=>{
						_this.form.address = result.data.name
						_this.name=result.data.name
					})
				},
				fail:function(res){
					console.log(res)
				}
			})



























		},
		queryLocation(){
			this.boolShow=true
			this.search()
		}
	}
}
